export enum NetworkLogsEventTypeEnum {
  AFTER_CONNECTION_ESTABLISHED = 'afterConnectionEstablished',
  AFTER_CONNECTION_CLOSED = 'afterConnectionClosed',
  HANDLE_CONNECTION_ERROR = 'handleConnectionError',
}
